<template>
    <div>
        <ReservationHeader />

        <div class="container">
            <div class="row" v-if="!reservationTimedOut">
                <div class="col-12 col-lg-8">
                    <ReservationNavigation />

                    <RouterView v-slot="{ Component }: { Component: any }">
                        <transition name="fade_top">
                            <component :is="Component" />
                        </transition>
                    </RouterView>
                </div>

                <div class="col-4" v-if="!isMobile">
                    <ReservationOverview />
                </div>
            </div>
        </div>

        <ReservationExpirationModal />
    </div>
</template>

<script lang="ts" setup>
import {
    onBeforeMount, onMounted, watch,
} from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { DateTime } from 'luxon';
import ReservationHeader from './components/ReservationHeader.vue';
import ReservationNavigation from './components/ReservationNavigation.vue';
import ReservationOverview from './components/ReservationOverview.vue';
import ReservationExpirationModal from './components/ReservationExpirationModal.vue';
import { useDevice } from './modules/useDevice';
import { pushRoute, Route } from './router';
import { useErrorMessage } from './modules/useErrorMessage';
import { useReservationTime } from './modules/useReservationTime';
import { useLocalTravellers } from './modules/useLocalTravellers';
import { useReservation } from './modules/useReservation';

const currentRoute = useRoute();
const { isMobile } = useDevice();
const { setErrorMessage } = useErrorMessage();

const { reservationTimeState } = useReservationTime();
const { localTravellersRef } = useLocalTravellers();
const { reservationState } = useReservation();
const { reservationTimedOut, stopCounter, startCounter } = useReservationTime();

window.addEventListener('resize', () => {
    if (!isMobile && currentRoute.name === Route.Overview) {
        pushRoute(Route.InvoiceData);
    }
});

onBeforeMount(() => {
    if (
        (currentRoute.name === Route.TravellersData && localTravellersRef.value.length <= 0)
        || (Object.values(reservationState.value?.travellers ?? {}).length <= 0 && currentRoute.name !== Route.NumberOfTravellers && currentRoute.name !== Route.TravellersData)
    ) {
        pushRoute(Route.NumberOfTravellers);
    }
});

onMounted(() => {
    const placeholders = document.getElementById('reservation-placeholders');

    placeholders?.parentNode?.removeChild(placeholders);

    document.addEventListener('visibilitychange', () => {
        if (!reservationState.value.finish_until || document.visibilityState !== 'visible') {
            return;
        }

        const now = DateTime.fromISO(reservationState.value.finish_until);

        stopCounter();
        reservationTimeState.timeUntilReservationEnds = Math.floor(now.diffNow().as('second'));

        setTimeout(() => {
            startCounter();
        }, 300);
    });
});

watch(currentRoute, () => {
    window.scrollTo(0, window.innerWidth >= 768 ? 97 : 72);
    setErrorMessage(null);

    if (currentRoute.name !== Route.TravellersData) {
        reservationTimeState.showRemainingTimeNotice = false;
    }
});
</script>
